import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/lock.svg";
var LockSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  LockSolid_default as default
};
